export function _chunkBalanced<T>(array: readonly T[], size = 1): T[][] {
  const a: T[][] = []
  for (let i = 0; i < array.length; i += size) {
    a.push(array.slice(i, i + size))
  }
  if (a.length <= 1) return a

  const lastLen = a[a.length - 1]!.length
  const maxLen = a[0]!.length
  const diff = maxLen - lastLen
  if (diff <= 1) return a
  const incr = Math.round((maxLen - lastLen) / 2)
  const a2 = [...a[a.length - 2]!, ...a[a.length - 1]!]

  a[a.length - 2] = a2.slice(0, lastLen + incr)
  a[a.length - 1] = a2.slice(a[a.length - 2]!.length)

  return a
}
